/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/react-in-jsx-scope */
// import { constants } from "buffer";
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useApi } from '../../hooks/userApi';
import { User } from '../../types/user';
import { AuthContext } from './AuthContext';
import jwt_decode from 'jwt-decode';

export const AuthProvider = ({ children }: { children: JSX.Element }) => {
  const [user, setUser] = useState<User | null>(null);
  const api = useApi();

  useEffect(() => {
    const validateToken = async () => {
      const storageData = sessionStorage.getItem('authToken');
      const storageDataUser = sessionStorage.getItem('user');

      if (storageData !== '') {
        setUser(JSON.parse(storageDataUser));
      }
      // if (storageData) {
      //     const data = await api.validateToken(storageData);
      //     if(data.user) {
      //         setUser(data.user);
      //     }
      // }
    };
    validateToken();
  }, []);

  const signin = async (email: string, password: string) => {
    const data = await api.signin(email, password);
    if (data.user && data.token) {
      const user: User = data.user;
      user.permissions = data.permissions;
      user.email = email;
      setUser(user);
      sessionStorage.setItem('authToken', 'Bearer '.concat(data.token));
      sessionStorage.setItem('user', JSON.stringify(user));
      return true;
    }

    return false;
  };

  const signout = async () => {
    await api.logout();
    setUser(null);
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('user');
    sessionStorage.getItem('authToken');
    sessionStorage.getItem('user');
  };

  return <AuthContext.Provider value={{ user, signin, signout }}>{children}</AuthContext.Provider>;
};
